<div class="row onetimepay-container">
  <div class="column twelve lg-eight lg-push-two md-eight md-push-two">
    <h1
      class="margin-bottom-10"
      dsContent
      [contentPath]="'billing.oneTimePayRefactor.chooseOneTimePayAccountsHeader'"
    ></h1>
    @if (showAutoPaySetUpLink$ | async) {
      <a role="button" (click)="goToSetUpAutoPayFlow()">
        {{ setUpAutoPaySubHeader }}
      </a>
    }
    <p
      class="margin-bottom-30 margin-top-30"
      dsContent
      [contentPath]="'billing.oneTimePayRefactor.chooseOneTimePayAccountsSubHeader2'"
    ></p>
    <form [formGroup]="billAccountSelectionFormGroup">
      <ds-checkbox-group
        data-cy="chooseAccountCheckbox"
        [controlName]="'option'"
        [parentFormGroup]="billAccountSelectionFormGroup"
        [options]="billAccountOptions$ | async"
        [displayClass]="'grid'"
        (option)="handleCheckBoxInteraction()"
      ></ds-checkbox-group>
      <call-to-action
        [tertiaryButtonName]="'Cancel'"
        [disabled]="billAccountSelectionFormGroup.invalid"
        [primaryButtonName]="'CONTINUE'"
        (primaryEvent)="submit()"
        (tertiaryEvent)="cancel()"
      ></call-to-action>
    </form>
  </div>
</div>

<ds-alert-modal
  [config]="silentRegistrationAllFailedError"
  (primaryEvent)="closeSilentRegistrationErrorModal()"
>
</ds-alert-modal>
<ds-alert-modal
  [config]="silentRegistrationPartialError"
  (primaryEvent)="continueWithSuccessfulRegistration()"
  (secondaryEvent)="closeSilentRegistrationErrorModal()"
>
</ds-alert-modal>

<ds-alert-modal
  [config]="cancelModalConfig"
  (primaryEvent)="leave()"
  (tertiaryEvent)="stay()"
></ds-alert-modal>
